<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { locale, t } = useI18n()
</script>

<template>
  <!-- Alimama ShuHeiTi Bold 1.000; source and license: docs/brand-wordmark.md. -->
  <svg v-if="locale === 'zh-CN'" class="app-wordmark" viewBox="0 0 1968 905" width="36" height="16" fill="currentColor" aria-hidden="true" focusable="false">
    <g transform="translate(-28 805) scale(1 -1)">
      <path d="M72 532H178Q178 346 172 214Q166 82 141-48H28Q53 78 62.5 218Q72 358 72 532ZM51 697H207V805H331V697H399V573H331V453L394 402V251L331 302V-100H207V573H51ZM420 322V790H920V30H963V-100H803V22H726L669 196L612 22H521Q513-41 503-100H380Q420 91 420 322ZM608 328 537 544V322Q537 197 527 88ZM621 605 670 454 720 605H803V670H537V605ZM803 112V566L727 337Z" />
      <path transform="translate(1041)" d="M415 480H783V651H405V782H913V351H545V48H825V158H955V-83H415ZM35 515H265V94L361 126V-23L133-100V382H35ZM229 800 298 583H162L93 800Z" />
    </g>
  </svg>
  <span v-else>{{ t('app.name') }}</span>
</template>

<style scoped>
.app-wordmark { display: block; width: 2.25rem; height: 1rem; flex: none; color: var(--primary); }
</style>
